const GROUP_CHARACTER_LIMIT = 55;

export default function getUserDisplayName(user) {
  const positionText = user.position ? getGroupText(user.position, user.positions.length) : '';
  const locationText = user.location ? getGroupText(user.location, user.locations.length) : '';

  if (positionText && locationText) {
    return `${user.fullname} (${positionText}, ${locationText})`;
  }

  if (positionText) {
    return `${user.fullname} (${positionText})`;
  }

  if (user.location) {
    return `${user.fullname} (${locationText})`;
  }

  return user.fullname;
}

function getGroupText(fullText, groupsCount) {
  let text = '';
  if (fullText && fullText.length <= GROUP_CHARACTER_LIMIT) {
    text = fullText;
  } else if (fullText) {
    const displayedNames = fullText.substr(0, GROUP_CHARACTER_LIMIT).split(', ');
    const ellipsis = fullText[GROUP_CHARACTER_LIMIT] !== ',' ? '...' : '';
    const suffix =
      displayedNames.length !== groupsCount
        ? ` and ${groupsCount - displayedNames.length} more`
        : '';

    text = `${displayedNames.join(', ')}${ellipsis}${suffix}`;
  }

  return text;
}
